import { MouseEvent, useRef } from 'react';
import classnames from 'classnames';

import { HSpacing } from '@hh.ru/magritte-ui';
import { ExclamationTriangleFilledSize16 } from '@hh.ru/magritte-ui/icon';
import { TelegramSolidSize16, ViberSolidSize16, WhatsappSolidSize16 } from '@hh.ru/magritte-ui/service';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { Messenger } from 'src/components/ResumeCard/Body/Contacts/DeepLinks/types';
import VerticallyCentredIconSize16 from 'src/components/VerticallyCentredIconSize16';
import translation from 'src/components/translation';

import styles from './styles.less';

const MESSENGER_ICON_MAP = {
    [Messenger.Telegram]: TelegramSolidSize16,
    [Messenger.Viber]: ViberSolidSize16,
    [Messenger.Whatsapp]: WhatsappSolidSize16,
};

const TrlKeys = {
    [Messenger.Telegram]: 'rb.personalsites.telegram',
    [Messenger.Viber]: 'rb.personalsites.viber',
    [Messenger.Whatsapp]: 'rb.personalsites.whatsapp',
};

interface Props {
    type: Messenger;
    handlePhoneCheck: (type: Messenger, event: MouseEvent) => Promise<void>;
    isWarning: boolean;
}

const MessengerDeepLink: TranslatedComponent<Props> = ({ type, handlePhoneCheck, isWarning, trls }) => {
    const activatorRef = useRef<HTMLSpanElement>(null);

    const MessengerIcon = MESSENGER_ICON_MAP[type];

    return (
        <span
            className={classnames(styles.messengerDeepLink, 'noprint')}
            onClick={(event) => handlePhoneCheck(type, event)}
            ref={activatorRef}
            data-interactive
            data-qa={classnames('resume-card-deep-link', `resume-card-deep-link_${type}`)}
        >
            <VerticallyCentredIconSize16 icon={<MessengerIcon initialColor="tertiary" />} />
            {isWarning && (
                <>
                    <HSpacing default={4} />
                    <VerticallyCentredIconSize16 icon={<ExclamationTriangleFilledSize16 initialColor="negative" />} />
                </>
            )}
            <HSpacing default={4} />
            {trls[TrlKeys[type]]}
        </span>
    );
};

export default translation(MessengerDeepLink);
